import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-selection-card',
  templateUrl: './selection-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class SelectionCardComponent {
  @Input() content: string;
  @Input() header: string;
  @Input() iconClass = 'fa-solid fa-location-dot';
  @Input() isClickable = false;

  @Output() onClick = new EventEmitter<void>();
}
